<template>
  <section>
    <!-- Header -->
    <div class="row mb-2">
      <div class="col-md-1">
        <button class="btn btn-primary btn-sm" @click="addMessage">Add</button>
      </div>
      <div class="col-md-11"></div>
    </div>
    <!-- Listing -->
    <div class="custom-wrapper">
      <z-table
        :value="messages"
        sortBy="id"
        orderBy="asc"
        :columns="tableColumns"
        :isSingleRowDetail="false"
        @sort="setOrder"
        class="table table-bordered table-striped"
      >
        <template v-slot:tbody="props">
          <td class="z-column-60-center">
            <a href="#" @click="editMessage(props.row)">edit</a>
          </td>
          <th scope="row">{{ props.row.id }}</th>
          <td>{{ props.row.subject }}</td>
          <td>{{ props.row.type }}</td>
          <td class="z-column-60-center">{{ yesNo(props.row.isInvite) }}</td>
          <td class="z-column-60-center">{{ yesNo(props.row.isInactive) }}</td>
          <td class="z-column-60-center">
            <a href="#" @click="deleteMessage(props.row)">remove</a>
          </td>
        </template>
        <template v-slot:empty> Nothing found! </template>
      </z-table>
    </div>
    <user-messages-dialog
      id="user-messages-modal"
      :show="actionMessage"
      @close="closeMessage"
      @saved="savedMessage"
    />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZTable from '@/Components/ZElements/Table'
import UserMessagesDialog from '@/Components/Users/forms/user-messages-dialog'
export default {
  name: 'user-messages-listing',
  components: {
    ZTable,
    UserMessagesDialog,
  },
  data() {
    return {
      actionMessage: null,
    }
  },
  mounted() {
    this.getMessages()
  },
  computed: {
    ...mapGetters('users', ['user']),
    ...mapGetters('messages', ['cannedmessages']),
    tableColumns() {
      return [
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        { field: 'Name', label: 'Name', sortable: true },
        { field: 'Type', label: 'Type', sortable: true },
        { field: 'IsInvite', label: 'IsInvite', sortable: false },
        { field: 'Inactive', label: 'Inactive', sortable: false },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
      ]
    },
    messages() {
      let _data = []
      if (this.cannedmessages) {
        _data = this.cannedmessages
      }
      return _data
    },
  },
  methods: {
    ...mapActions('messages', [
      'getCannedMessages',
      'getCannedMessage',
      'removeCannedMessage',
      'resetCannedMessage',
    ]),
    yesNo(value) {
      let _data = ''
      if (value) {
        _data = 'Y'
      }
      return _data
    },
    async getMessages() {
      await this.getCannedMessages(this.user.detail.id)
    },
    setOrder() {},
    closeMessage() {
      this.actionMessage = null
    },
    savedMessage() {
      this.actionMessage = null
      this.getMessages()
    },
    addMessage() {
      this.resetCannedMessage({
        userid: this.user.detail.id,
        orgid: this.user.detail.currentorganization_id,
      })
      this.actionMessage = {
        isAdd: true,
        data: null,
      }
    },
    async editMessage(row) {
      await this.getCannedMessage(row.id)
      this.actionMessage = {
        isAdd: false,
        data: null,
      }
    },
    async deleteMessage(row) {
      await this.removeCannedMessage(row.id)
      await this.getMessages()
    },
  },
}
</script>
<style scoped>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
